import React, { useLayoutEffect } from 'react';
import { BrowserRouter, Link, Navigate, Route, Routes, useLocation, useParams } from 'react-router-dom';
import ArchiveShell from '../components/archive/ArchiveShell/ArchiveShell';
import HomePage from '../pages/HomePage/HomePage';
import ThoughtsPage from '../pages/ThoughtsPage/ThoughtsPage';
import ThoughtPage from '../pages/DataItemPage/DataItemPage';
import WorkPage from '../pages/WorkPage/WorkPage';
import ProjectPage from '../pages/ProjectPage/ProjectPage';
import AboutPage from '../pages/AboutPage/AboutPage';
import ArchivePage from '../pages/ArchivePage/ArchivePage';
import './App.css';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    const fileWindow = document.getElementById('main-content');
    if (fileWindow) fileWindow.scrollTop = 0;
  }, [pathname]);
  return null;
};

const LegacyThoughtRoute = () => {
  const { slug } = useParams();
  return <Navigate replace to={`/thoughts/${slug}`} />;
};

const NotFound = () => <div className="record-page not-found"><p className="record-kicker">Record unavailable / 404</p><h1>This file is not in the public index.</h1><Link className="record-action" to="/archive">Return to archive</Link></div>;

const RoutedArchive = () => <><ScrollToTop /><ArchiveShell><Routes>
  <Route path="/" element={<HomePage />} />
  <Route path="/work" element={<WorkPage />} />
  <Route path="/work/:projectId" element={<ProjectPage />} />
  <Route path="/blog" element={<ThoughtsPage />} />
  <Route path="/blog/:slug" element={<ThoughtPage />} />
  <Route path="/thoughts" element={<ThoughtsPage />} />
  <Route path="/thoughts/:slug" element={<ThoughtPage />} />
  <Route path="/database/:slug" element={<LegacyThoughtRoute />} />
  <Route path="/about" element={<AboutPage />} />
  <Route path="/archive" element={<ArchivePage />} />
  <Route path="*" element={<NotFound />} />
</Routes></ArchiveShell></>;

function App() {
  return <BrowserRouter><RoutedArchive /></BrowserRouter>;
}

export default App;
